module.exports = __webpack_public_path__ + "static/media/vi1.be389699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vi1.png
// module id = 311
// module chunks = 0